"use strict";

import { startListening } from './handlers/gestures/eventReceiver';
export function initialize() {
  startListening();
}
//# sourceMappingURL=init.js.map